<template>
  <v-card>
    <v-container fluid :style="{ whiteSpace: 'pre-wrap' }">
      <v-row dense align="center" justify="end">
        <v-col class="font-weight-bold">
          {{ medicalReport.name }}
        </v-col>
        <v-col cols="auto">
          <authorization
            permissionKey="attendance_medical_record"
            can="print"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :disabled="false"
                  :loading="printLoading"
                  @click="downloadmedicalReport" 
                >
                  <v-icon>eva-printer-outline</v-icon>
                </v-btn>
              </template>
              <span>
                 Imprimir
              </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowEdit"
            permissionKey="attendance_medical_record"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :to="`relatorio/${medicalReport.id}`"
                  v-if="authorization"
                >
                  <!-- :disabled="signed"-->
                  <v-icon>eva-edit-outline</v-icon>
                </v-btn>
              </template>

              <span> Editar </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowDelete"
            permissionKey="attendance_medical_record"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  @click="deleteMedicalReport"
                  v-if="authorization"
                >
                  <!-- :disabled="signed" -->
                  <v-icon>eva-trash-outline</v-icon>
                </v-btn>
              </template>

              <span> Excluir </span>
            </v-tooltip>
          </authorization>

          <v-btn icon small @click="showContent = !showContent">
            <v-icon v-if="showContent">eva-chevron-up-outline</v-icon>
            <v-icon v-else>eva-chevron-down-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="showContent">
        <v-col>
          <v-divider />
          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">
                  Relatório
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <span v-html= medicalReport.description ></span>
                  
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "MedicalReportListItem",
  props: {
    medicalReport: Object,
    index: Number,
    refreshList: Function,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    forcePrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printLoading: false,
      showContent: true,
    };
  },
  computed: {
    // signed() {
    //   return true //this.medicalReport.lastEsign.status !== "editable";
    // },
  },
  methods: {
    deleteMedicalReport() {
      //if (this.signed) return;
      if (confirm("Você realmente deseja deletar esse relatório?")) {
        this.apolloMutate({
          mutation: require("@/graphql/medical_report/delete_medical_report.gql"),
          variables: {
            medicalReportId: this.medicalReport.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Relatório deletada com sucesso.",
            type: "success",
          });
        });
      }
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.medicalReport.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true,
        },
      });
      await setTimeout(() => {
        this.refreshList();
      }, 10000);
    },
    async downloadmedicalReport() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refreshList();
      //await this.$store.dispatch("authentication/refreshToken");

      //if (this.glassesPrescription.lastEsign.status === "signed") {
      const file_url = this.medicalReport.lastEsign.fileUrl;

      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
      // } else {
      //   this.$store.dispatch("createNotification", {
      //     message: "É necessário assinar antes de imprimir.",
      //     type: "error",
      //   });
      //}

      this.printLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  white-space: pre-line;
}
</style>
